module.exports = (__webpack_require__("bricks/next-builder:bbjC"))("/TIM");